import React from 'react'
import './portfolio_modal.css'
import CloseIcon from '@mui/icons-material/Close';

export default function PortfolioModal({ photo_url, description, delegateClose }) {

    return (
        <div id="portfolio-modal-container" className="requires-no-scroll">
            {/* <span className="modal-close-btn" onClick={delegateClose} >X</span> */}

            <div id="portfolio-modal">
                <CloseIcon className='modal-close-btn' onClick={delegateClose} />
                <img className='portfolio-modal' src={photo_url} alt={description} />
            </div>
        </div>
    )

}

